var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bio"},[_c('span',{class:_vm.bioIconClasses},[(_vm.icon)?_c('Icon',{attrs:{"icon":_vm.icon,"path":_vm.path}}):_c('Repr',{attrs:{"path":_vm.path}})],1),_c('div',{staticClass:"text"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }